import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatTableModule } from '@angular/material/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MyLoaderComponent } from './my-loader/my-loader.component';
import { SharedService } from './shared.service';
import { HttpErrorInterceptorProvider } from './http-error-interceptor.service';
import { LoaderService } from './loader.service';
import { LoaderInterceptor } from './loader-interceptor.service';
import { MaterialModulesModule } from './material-modules.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CustomThemeUtility } from './customThemeUtil';

@NgModule({
  declarations: [
    MyLoaderComponent
  ],
  imports: [
    NgbModule,
    FormsModule,
    CommonModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    MaterialModulesModule,
    MatExpansionModule
  ],
  providers: [
    MatTableModule,
    SharedService,
    CustomThemeUtility,
    HttpErrorInterceptorProvider,
    LoaderService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
  ],
  exports: [
    MyLoaderComponent
  ]
})
export class SharedModule {}
